/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_6_QInputs */

const en_vc_faq_6_q = /** @type {(inputs: Vc_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this the VectorCraft Figma plugin?`)
};

const zh_vc_faq_6_q = /** @type {(inputs: Vc_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是那个叫 VectorCraft 的 Figma 插件吗？`)
};

/**
* | output |
* | --- |
* | "Is this the VectorCraft Figma plugin?" |
*
* @param {Vc_Faq_6_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_6_q = /** @type {((inputs?: Vc_Faq_6_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_6_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_6_q(inputs)
	return zh_vc_faq_6_q(inputs)
});
export { vc_faq_6_q as "vc.faq.6.q" }